<template>
    <div class="o-services-modal-label">
        <div class="services-modal-label-container">
            <div
                v-if="icon"
                class="services-modal-main-label-icon-container"
            >
                <img
                    class="services-modal-main-label-icon"
                    :src="icon"
                    :alt="`${$t('services-modal_label-icon')}`"
                >
            </div>
            <div class="services-modal-main-label-info">
                <span class="services-modal-main-label-text">
                    {{ name }}
                </span>
            </div>
        </div>
        <div class="services-modal-label-footer">
            <AAmountInfo
                :text="amountServicesText"
            />
        </div>
    </div>
</template>

<script>
import AAmountInfo from '../../atoms/a-amount-info';

export default {
    name: "OServicesModalLabel",
    props: {
        icon: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        amountServicesText: {
            type: String,
            default: ''
        }
    },
    components: {
        AAmountInfo
    }
}
</script>

<style lang="scss">
@import "theme";
</style>